<template>
  <canvas ref="canvas"></canvas>
</template>
<script>
import { BoxPlotChart } from "@sgratzl/chartjs-chart-boxplot";

export default {
  name: "BoxPlotChart",
  components: {
  },
  props: {
    datasets: { type: Array, },
    labels: { type: Array, },
    match_keys: { type: Array, },
    height: { type: Number, default: 400 },
    heightAdjustment: { type: Number, default: 0 },
    width: { type: Number, default: 300 },
    showLegend: { type: Boolean, default: true },
  },
  data: function () {
    return {
      chart: null,
    };
  },
  mounted() {
    if (this.datasets)
      this.setupChart();
  },
  beforeDestroy() {
    this.$refs.canvas?.removeEventListener('click', this.handleCanvasClick);
    if (this.chart) {
      this.chart.destroy();
      this.chart = null;
    }
  },
  watch: {
    datasets(val) {
      if (val) this.setupChart();
    },    
  },
  computed: {
  },
  methods: {
    setupChart() {
      if (this.chart) {
        this.chart.destroy();
        this.chart = null;
      }
      const ctx = this.$refs.canvas?.getContext("2d");
      if (!ctx) return;
      ctx.canvas.parentNode.style.width = `${this.width}px`;
      ctx.canvas.parentNode.style.height = `${this.height + this.heightAdjustment}px`;
      this.chart = new BoxPlotChart(ctx, {
        type: 'boxplot',
        // @ts-ignore
        data: { datasets: this.datasets, labels: this.labels || [], match_keys: this.match_keys || [] },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          clip: false,
          onHover: (event, elements, chart) => {
            chart.canvas.style.cursor = 'pointer';
          },
          title: {
            display: true,
            text: "title",
          },
          legend: {
            position: 'top',
          },
          plugins: {
            datalabels: {
              display: true,
            },
            legend: {
              display: this.showLegend,
            },
            tooltip: {
              // displayColors: false,
              // bodyFont: {
              //   size: 12,
              //   family: "Inter",
              // },
              // bodyColor: "#4771FA",
              // backgroundColor: "white",
              callbacks: {
                title: (title) => {
                  // return `${title[0].label} - ${title[0].dataset.label}`;
                  return `${title[0].label}`;
                },
                label: (context) => {
                  const boxplotValues = [
                    `  Number of ${context.dataset.label}s: ${context.parsed.items.length}`,
                    `  - Max: ${context.parsed.max.toFixed(0)}`,
                    `  - Q1: ${context.parsed.q1.toFixed(0)}`,
                    `  - Mean: ${context.parsed.mean.toFixed(0)}`,
                    `  - Median: ${context.parsed.median.toFixed(0)}`,
                    `  - Q3: ${context.parsed.q3.toFixed(0)}`,
                    `  - Min: ${context.parsed.min.toFixed(0)}`,
                  ];
                  return boxplotValues;
                },
              },
            },
          },
          // layout: {
          //   padding: {
          //     left: 10,
          //     right: 5,
          //     top: 70,
          //     bottom: 5,
          //   },
          // },
          scales: {
            y: {
              beginAtZero: false,
            },
          },
        },
      });
      this.$refs.canvas.removeEventListener('click', this.handleCanvasClick);
      this.$refs.canvas.addEventListener('click', this.handleCanvasClick);
    },
    handleCanvasClick(event) {
      if (!this.chart) return;
      const rect = this.$refs.canvas.getBoundingClientRect();
      const x = event.clientX - rect.left;
      const xScale = this.chart.scales.x;
      if (!xScale) return;
      const index = xScale.getValueForPixel(x);
      if (index == null || index < 0 || index >= (this.chart.data.labels?.length || 0)) return;
      const elements = this.chart.getElementsAtEventForMode(event, 'nearest', { intersect: true }, false);
      const datasetIndex = elements.length > 0 ? elements[0].datasetIndex : 0;
      this.$emit('chartClick', {
        datasetIndex,
        index,
        label: this.chart.data.labels?.[index],
        dataset: this.chart.data.datasets[datasetIndex],
        data: this.chart.data.datasets[datasetIndex].data[index],
        match_key: this.chart.data.match_keys?.[index],
      });
    },
  }
};
</script>
<style scoped lang="scss">
</style>